/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
      this.liveRegion = null;
    }
    connectedCallback() {
      setTimeout(() => {
        this.target = this.dataset.target;
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.createLiveRegion();
        this.buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.activateTab(button, i);
            event.preventDefault();
          });
          button.addEventListener('keydown', (event) => {
            this.handleKeydown(event, i);
          });
        });
      }, 20);
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.buttons.indexOf(event.target);

          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }
    }
    createLiveRegion() {
      this.liveRegion = document.createElement('div');
      this.liveRegion.setAttribute('aria-live', 'assertive');
      this.liveRegion.setAttribute('aria-atomic', 'true');
      this.liveRegion.setAttribute('class', 'visually-hidden');
      this.liveRegion.setAttribute('role', 'status');
      document.body.appendChild(this.liveRegion);
    }
    activateTab(button, index) {
      let handle = button.dataset.collection;
      const tabLabel = button.textContent.trim();
      
      // Update all buttons
      this.buttons.forEach((btn, i) => {
        const isActive = i === index;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-selected', isActive);
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      if (handle) {
        this.toggleCollection(handle, tabLabel, button);
      }
    }
    handleKeydown(event, currentIndex) {
      let newIndex = currentIndex;
      
      switch(event.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          event.preventDefault();
          newIndex = currentIndex > 0 ? currentIndex - 1 : this.buttons.length - 1;
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          event.preventDefault();
          newIndex = currentIndex < this.buttons.length - 1 ? currentIndex + 1 : 0;
          break;
        case 'Home':
          event.preventDefault();
          newIndex = 0;
          break;
        case 'End':
          event.preventDefault();
          newIndex = this.buttons.length - 1;
          break;
        default:
          return;
      }
      
      this.buttons[newIndex].focus();
      this.activateTab(this.buttons[newIndex], newIndex);
    }
    toggleCollection(handle, tabLabel, button) {
      let slider = document.getElementById(this.target),
        products = slider.querySelectorAll(`.columns:not([data-collection*="${handle}"])`),
        active_products = slider.querySelectorAll(`[data-collection*="${handle}"]`),
        flkty = Flickity.data(slider);
      [].forEach.call(products, function(el) {
        el.classList.remove('carousel__slide');
        slider.append(el);
      });
      [].forEach.call(active_products, function(el) {
        if (el.dataset.collection === handle) {
          el.classList.add('carousel__slide');
        } else {
          el.classList.remove('carousel__slide');
          slider.append(el);
        }
      });
      flkty.insert(active_products);
      flkty.reloadCells();
      flkty.select(0, 0, 1);
      
      // Update tabpanel aria-labelledby to match active tab
      const tabpanelWrapper = slider.closest('[role="tabpanel"]');
      if (tabpanelWrapper && button.id) {
        tabpanelWrapper.setAttribute('aria-labelledby', button.id);
      }
      
      // Announce the change to screen readers
      if (this.liveRegion) {
        this.liveRegion.textContent = '';
        setTimeout(() => {
          this.liveRegion.textContent = `${tabLabel} products loaded`;
        }, 100);
      }
      
      // Move focus to the tabpanel for better screen reader experience
      if (tabpanelWrapper) {
        setTimeout(() => {
          tabpanelWrapper.focus();
        }, 150);
      }
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}
